function version() {
    this.appVersion='dev';
}

module.exports = new version();
